//import { Token } from "../../pages/portfolio/Portfolio.jsx";
import React, { useState } from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Tab } from "@material-ui/core";
//import { WalletBalance } from "./WalletBalance";
//import { StakeForm } from "./StakeForm";
import { useDispatch, useSelector } from "react-redux";
// import { updateBlockchain, updateFilterStatus, selectBlockchain } from '../../redux/Filters';
import {
  updateBlockchain,
  updateFilterStatus,
} from "../../rtk/features/filter/filterSlice";

const useStyles = makeStyles((theme) => ({
  tabContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
  },
  box: {
    backgroundColor: "white",
    borderRadius: "25px",
  },
}));

export const FilterBlockchain = ({ supportedTokens }) => {
  const [selectedTokenIndex, setSelectedTokenIndex] = useState(0);
  const dispatch = useDispatch();
  // const blockchainValue = useSelector(selectBlockchain);
  const blockchainValue = useSelector((state) => state.filter.blockchain);

  const handleChange = (event, newValue) => {
    setSelectedTokenIndex(parseInt(newValue));
    dispatch(updateBlockchain([newValue]));
    dispatch(updateFilterStatus(true));
  };
  const classes = useStyles();
  let trigger = true;
  if (blockchainValue.length <= 1) {
    if (blockchainValue.length === 1) {
      if (supportedTokens.find((e) => e.name === blockchainValue[0]))
        trigger = true;
      else trigger = false;
    }
  } else trigger = false;

  return (
    trigger && (
      <Box>
        <Box className={classes.box}>
          <TabContext value={blockchainValue[0]}>
            <TabList onChange={handleChange} aria-label="stake form tabs">
              {supportedTokens.map((token, index) => {
                return (
                  <Tab label={token.name} value={token.name} key={index} />
                );
              })}
            </TabList>
            {supportedTokens.map((token, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <div className={classes.tabContent}>
                    {/*<WalletBalance token={supportedTokens[selectedTokenIndex]} />
                    <StakeForm token={supportedTokens[selectedTokenIndex]} />*/}
                  </div>
                </TabPanel>
              );
            })}
          </TabContext>
        </Box>
      </Box>
    )
  );
};
